module.exports = __webpack_public_path__ + "static/media/ACHALGARH FORT SMALL AND BIG.326316cc.png";